/**
 * In-memory quota cache populated by StudioMetricsProvider live listeners.
 * Allows count*AcrossStudio helpers to avoid O(projects × captures) getDocs scans
 * when the provider is mounted for the same uid.
 */

/** @type {Map<string, { processingCount: number, completedCount: number, captures: Array<object>, planStartedAtMs: number | null, updatedAt: number }>} */
const cacheByUid = new Map();

/** @param {string} uid */
export function getStudioQuotaCache(uid) {
  if (!uid) return null;
  return cacheByUid.get(uid) ?? null;
}

/**
 * @param {string} uid
 * @param {{ processingCount: number, completedCount: number, captures?: Array<object>, planStartedAtMs?: number | null }} counts
 */
export function setStudioQuotaCache(uid, counts) {
  if (!uid) return;
  const prev = cacheByUid.get(uid);
  cacheByUid.set(uid, {
    processingCount: counts.processingCount ?? 0,
    completedCount: counts.completedCount ?? 0,
    captures: counts.captures ?? prev?.captures ?? [],
    planStartedAtMs:
      counts.planStartedAtMs !== undefined ? counts.planStartedAtMs : (prev?.planStartedAtMs ?? null),
    updatedAt: Date.now(),
  });
}

/** @param {string} uid */
export function clearStudioQuotaCache(uid) {
  if (uid) cacheByUid.delete(uid);
  else cacheByUid.clear();
}
